"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePersonalData = void 0;
/* eslint-disable react-hooks/exhaustive-deps */
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const UpdatePersonalData_style_1 = require("./UpdatePersonalData.style");
const GlobalStyles_1 = require("../../../helper/GlobalStyles");
const atome_1 = require("../../atome");
const organisms_1 = require("../../organisms");
const User_service_1 = __importDefault(require("../../../services/User.service"));
const enums_1 = require("../../../enums");
const Breakpoints_1 = require("../../../helper/Breakpoints");
const hooks_1 = require("../../../store/hooks");
const reducers_1 = require("../../../store/reducers");
const InputLoader_1 = __importDefault(require("../../atome/InputLoader/InputLoader"));
// @ts-ignore
function UpdatePersonalData({ navigation, setUserInfo }) {
    const userInformation = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [isSaving, setSaving] = (0, react_1.useState)(false);
    const [saveSuccess, setSaveSuccess] = (0, react_1.useState)(false);
    const [addressID, setAddressID] = (0, react_1.useState)(0);
    const [street, setStreet] = (0, react_1.useState)('');
    const [houseNumber, setHouseNumber] = (0, react_1.useState)('');
    const [zip, setZip] = (0, react_1.useState)('');
    const [location, setLocation] = (0, react_1.useState)('');
    const [country, setCountry] = (0, react_1.useState)('');
    const [mobileNumber, setMobileNumber] = (0, react_1.useState)('');
    const [email, setEmail] = (0, react_1.useState)('');
    const [error, setError] = (0, react_1.useState)({
        firstnameEmpty: false,
        lastnameEmpty: false,
        streetEmpty: false,
        houseNumberEmpty: false,
        zipEmpty: false,
        locationEmpty: false,
        countryEmpty: false,
        phoneEmpty: false,
        mobileShort: false,
        mobileLong: false,
        emailEmpty: false,
        emailCorrect: false,
    });
    const [initialState, setInitialState] = (0, react_1.useState)({
        email: '',
        mobile: '',
        addressId: -1,
        street: '',
        postcode: '',
        houseNumber: '',
        country: '',
        city: '',
    });
    const getUserData = async () => {
        const information = userInformation;
        (0, reducers_1.setUserInformation)(information);
        if (information) {
            setEmail(information.email);
            setMobileNumber(information.mobile);
            setAddressID(information.address[0].id);
            setStreet(information.address[0].street);
            setZip(information.address[0].postcode);
            setHouseNumber(information.address[0].houseNumber);
            setCountry(information.address[0].country);
            setLocation(information.address[0].city);
            setInitialState({
                email: information.email,
                mobile: information.mobile,
                addressId: information.address[0].id,
                street: information.address[0].street,
                postcode: information.address[0].postcode,
                houseNumber: information.address[0].houseNumber,
                country: information.address[0].country,
                city: information.address[0].city,
            });
        }
    };
    // Old Regex for email validation
    // const mailRegex =
    //   /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gm;
    const mailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    const SecondMailValidator = (mail = '') => {
        const after = mail.substring(mail.indexOf('@') + 1);
        const howManyMailSigns = after.split('.').length - 1;
        if (howManyMailSigns === 1) {
            return false;
        }
        return true;
    };
    const validate = () => {
        const newError = {
            streetEmpty: street === '',
            houseNumberEmpty: houseNumber === '',
            zipEmpty: zip === '',
            locationEmpty: location === '',
            countryEmpty: country === '',
            phoneEmpty: mobileNumber === '',
            mobileShort: mobileNumber.length < 6 && mobileNumber !== '',
            mobileLong: mobileNumber.length > 17,
            emailEmpty: email === '',
            emailCorrect: email === ''
                ? false
                : !mailRegex.test(email) || SecondMailValidator(email),
        };
        // @ts-ignore
        setError(newError);
        return newError;
    };
    const areValuesTheSame = () => initialState.email === email &&
        initialState.mobile === mobileNumber &&
        initialState.addressId === addressID &&
        initialState.street === street &&
        initialState.postcode === zip &&
        initialState.houseNumber === houseNumber &&
        initialState.country === country &&
        initialState.city === location;
    const save = async () => {
        const newError = validate();
        if (Object.values(newError).find(e => e)) {
            return;
        }
        if (areValuesTheSame()) {
            setSaveSuccess(false);
            navigation.navigate('MyAccount');
            return;
        }
        const data = {
            email: email,
            mobile: mobileNumber,
            address: [
                {
                    id: addressID,
                    street: street,
                    postcode: zip,
                    houseNumber: houseNumber,
                    country: country,
                    city: location,
                },
            ],
        };
        setSaving(true);
        const response = await User_service_1.default.updateUserInfo(data);
        setSaving(false);
        if (response.error) {
            console.log(response.message);
        }
        if (!response.error) {
            const newUserInformation = { ...userInformation };
            newUserInformation.email = data.email;
            newUserInformation.mobile = data.mobile;
            newUserInformation.address = [...data.address];
            setSaveSuccess(true);
            dispatch((0, reducers_1.setUserInformation)(newUserInformation));
            setUserInfo(newUserInformation);
            setTimeout(() => {
                setSaveSuccess(false);
                navigation.navigate('MyAccount');
            }, 1000);
        }
    };
    (0, react_1.useEffect)(() => {
        return navigation.addListener('focus', async () => {
            setLoading(true);
            if (userInformation.id) {
                await getUserData();
            }
            setLoading(false);
        });
    }, []);
    (0, react_1.useEffect)(() => {
        getUserData().then(() => { });
    }, [userInformation]);
    if (loading) {
        return react_1.default.createElement(atome_1.Loading, null);
    }
    return (react_1.default.createElement(atome_1.ProtectedPage, { navigation: navigation },
        react_1.default.createElement(react_native_1.SafeAreaView, { style: [UpdatePersonalData_style_1.styles.whiteBackground] },
            react_1.default.createElement(react_native_1.ScrollView, { style: [UpdatePersonalData_style_1.styles.scrollview] },
                Breakpoints_1.isDesktop && react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
                react_1.default.createElement(react_native_1.View, { style: [UpdatePersonalData_style_1.styles.container] },
                    Breakpoints_1.isDesktop && (react_1.default.createElement(atome_1.Label, { style: [UpdatePersonalData_style_1.styles.heading1] }, "Kontaktdaten bearbeiten")),
                    react_1.default.createElement(atome_1.Label, { style: [UpdatePersonalData_style_1.styles.heading2] }, "Adresse"),
                    react_1.default.createElement(atome_1.Text, { style: [UpdatePersonalData_style_1.styles.descriptionText] }, "Bitte geben Sie Ihre Meldeadresse unbedingt vollst\u00E4ndig und korrekt an."),
                    react_1.default.createElement(react_native_1.View, { style: [
                            GlobalStyles_1.globalStyles.row,
                            Breakpoints_1.isDesktop ? GlobalStyles_1.globalStyles.marginBottom20 : null,
                        ] },
                        react_1.default.createElement(react_native_1.View, { style: [
                                Breakpoints_1.isMobile || Breakpoints_1.isTablet ? UpdatePersonalData_style_1.styles.marginRow : null,
                                Breakpoints_1.isMobile || Breakpoints_1.isTablet ? GlobalStyles_1.globalStyles.flex5 : null,
                                GlobalStyles_1.globalStyles.marginRight10,
                            ] },
                            react_1.default.createElement(atome_1.Label, { style: [UpdatePersonalData_style_1.styles.label] }, "Stra\u00DFe"),
                            react_1.default.createElement(atome_1.InputField, { hasError: error.streetEmpty, onChange: setStreet, value: street, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [UpdatePersonalData_style_1.styles.input] : [UpdatePersonalData_style_1.styles.streetField] }),
                            error.streetEmpty && (react_1.default.createElement(atome_1.Text, { style: [UpdatePersonalData_style_1.styles.errorText] }, enums_1.ErrorMessages.EMPTY_FIELD))),
                        react_1.default.createElement(react_native_1.View, { style: [
                                Breakpoints_1.isMobile || Breakpoints_1.isTablet ? UpdatePersonalData_style_1.styles.marginRow : null,
                                Breakpoints_1.isMobile || Breakpoints_1.isTablet ? GlobalStyles_1.globalStyles.flex3 : null,
                                GlobalStyles_1.globalStyles.marginLeft10,
                            ] },
                            react_1.default.createElement(atome_1.Label, { style: [UpdatePersonalData_style_1.styles.label] }, "Hausnummer"),
                            react_1.default.createElement(atome_1.InputField, { hasError: error.houseNumberEmpty, onChange: setHouseNumber, isNumber: true, value: houseNumber, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                    ? [UpdatePersonalData_style_1.styles.input]
                                    : [UpdatePersonalData_style_1.styles.houseNumberInputField] }),
                            error.houseNumberEmpty && (react_1.default.createElement(react_native_1.View, null,
                                react_1.default.createElement(atome_1.Text, { style: [
                                        UpdatePersonalData_style_1.styles.errorText,
                                        Breakpoints_1.isDesktop ? UpdatePersonalData_style_1.styles.width250 : UpdatePersonalData_style_1.styles.bottomMinus38,
                                    ] }, enums_1.ErrorMessages.EMPTY_FIELD))))),
                    react_1.default.createElement(react_native_1.View, { style: [Breakpoints_1.isDesktop ? GlobalStyles_1.globalStyles.row : GlobalStyles_1.globalStyles.column] },
                        react_1.default.createElement(react_native_1.View, { style: [
                                GlobalStyles_1.globalStyles.row,
                                error.zipEmpty && !Breakpoints_1.isDesktop
                                    ? GlobalStyles_1.globalStyles.marginBottom40
                                    : null,
                            ] },
                            react_1.default.createElement(react_native_1.View, { style: [
                                    Breakpoints_1.isMobile || Breakpoints_1.isTablet ? UpdatePersonalData_style_1.styles.marginRow : null,
                                    GlobalStyles_1.globalStyles.flex2,
                                    GlobalStyles_1.globalStyles.marginRight10,
                                ] },
                                react_1.default.createElement(atome_1.Label, { style: [UpdatePersonalData_style_1.styles.label] }, "PLZ"),
                                react_1.default.createElement(atome_1.InputField, { hasError: error.zipEmpty, onChange: setZip, value: zip, isNumber: true, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [UpdatePersonalData_style_1.styles.input] : undefined }),
                                error.zipEmpty && (react_1.default.createElement(react_native_1.View, null,
                                    react_1.default.createElement(atome_1.Text, { style: [UpdatePersonalData_style_1.styles.errorText, UpdatePersonalData_style_1.styles.bottomMinus38] }, enums_1.ErrorMessages.EMPTY_FIELD)))),
                            react_1.default.createElement(react_native_1.View, { style: [
                                    Breakpoints_1.isMobile || Breakpoints_1.isTablet ? UpdatePersonalData_style_1.styles.marginRow : null,
                                    GlobalStyles_1.globalStyles.flex4,
                                    GlobalStyles_1.globalStyles.marginLeft10,
                                ] },
                                react_1.default.createElement(atome_1.Label, { style: [UpdatePersonalData_style_1.styles.label] }, "Ort"),
                                react_1.default.createElement(atome_1.InputField, { hasError: error.locationEmpty, onChange: setLocation, value: location, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [UpdatePersonalData_style_1.styles.input] : undefined }),
                                error.locationEmpty && (react_1.default.createElement(atome_1.Text, { style: [UpdatePersonalData_style_1.styles.errorText] }, enums_1.ErrorMessages.EMPTY_FIELD)))),
                        react_1.default.createElement(react_native_1.View, null,
                            react_1.default.createElement(atome_1.Label, { style: [UpdatePersonalData_style_1.styles.label] }, "Land"),
                            react_native_1.Platform.OS === 'web' && (react_1.default.createElement(atome_1.PickerField, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                    ? [UpdatePersonalData_style_1.styles.input]
                                    : [UpdatePersonalData_style_1.styles.countryInputField], value: country, hasError: error.countryEmpty, onChange: setCountry, disableFirstLabel: country !== '', items: [
                                    { label: 'Deutschland', value: 'germany' },
                                    { label: 'Österreich', value: 'austria' },
                                    { label: 'Schweiz', value: 'switzerland' },
                                    { label: 'Belgien', value: 'belgium' },
                                    { label: 'Dänemark', value: 'denmark' },
                                    { label: 'Finnland', value: 'finland' },
                                    { label: 'Frankreich', value: 'france' },
                                    { label: 'Griechenland', value: 'greece' },
                                    { label: 'Italien', value: 'italy' },
                                    { label: 'Niederlande', value: 'netherlands' },
                                    { label: 'Norwegen', value: 'norway' },
                                    { label: 'Polen', value: 'poland' },
                                    { label: 'Portugal', value: 'portugal' },
                                    { label: 'Schweden', value: 'sweden' },
                                    { label: 'Spanien', value: 'spain' },
                                    { label: 'Tschechien', value: 'czechRepublic' },
                                    { label: 'Türkei', value: 'turkey' },
                                    { label: 'USA', value: 'unitedStates' },
                                    { label: 'Vereinigtes Königreich', value: 'unitedKingdom' },
                                ] })),
                            react_native_1.Platform.OS !== 'web' && (react_1.default.createElement(atome_1.PickerFieldSegmented, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [UpdatePersonalData_style_1.styles.picker] : undefined, currentValue: [country], setter: [setCountry], hasError: error.countryEmpty, firstLabels: [''], items: [
                                    {
                                        key: 'country',
                                        items: [
                                            { label: 'Deutschland', value: 'germany' },
                                            { label: 'Österreich', value: 'austria' },
                                            { label: 'Schweiz', value: 'switzerland' },
                                            { label: 'Belgien', value: 'belgium' },
                                            { label: 'Dänemark', value: 'denmark' },
                                            { label: 'Finnland', value: 'finland' },
                                            { label: 'Frankreich', value: 'france' },
                                            { label: 'Griechenland', value: 'greece' },
                                            { label: 'Italien', value: 'italy' },
                                            { label: 'Niederlande', value: 'netherlands' },
                                            { label: 'Norwegen', value: 'norway' },
                                            { label: 'Polen', value: 'poland' },
                                            { label: 'Portugal', value: 'portugal' },
                                            { label: 'Schweden', value: 'sweden' },
                                            { label: 'Spanien', value: 'spain' },
                                            { label: 'Tschechien', value: 'czechRepublic' },
                                            { label: 'Türkei', value: 'turkey' },
                                            { label: 'USA', value: 'unitedStates' },
                                            {
                                                label: 'Vereinigtes Königreich',
                                                value: 'unitedKingdom',
                                            },
                                        ],
                                    },
                                ] }))),
                        error.countryEmpty && (react_1.default.createElement(atome_1.Text, { style: [UpdatePersonalData_style_1.styles.errorText] }, enums_1.ErrorMessages.EMPTY_FIELD))),
                    react_1.default.createElement(atome_1.Label, { style: [UpdatePersonalData_style_1.styles.heading2] }, "Telefon / E-Mail"),
                    react_1.default.createElement(atome_1.Text, { style: [UpdatePersonalData_style_1.styles.descriptionText] }, "Wie k\u00F6nnen wir Sie erreichen? Sie k\u00F6nnen eine mobile und eine Festnetznummer hinterlegen oder nur eine von beiden."),
                    react_1.default.createElement(react_native_1.View, { style: [Breakpoints_1.isDesktop ? GlobalStyles_1.globalStyles.row : GlobalStyles_1.globalStyles.column] },
                        react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? UpdatePersonalData_style_1.styles.marginRow : null },
                            react_1.default.createElement(atome_1.Label, { style: [UpdatePersonalData_style_1.styles.label] }, "Telefon Mobil"),
                            react_1.default.createElement(atome_1.InputField, { hasError: error.phoneEmpty || error.mobileShort || error.mobileLong, onChange: setMobileNumber, value: mobileNumber, isNumber: true, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                    ? [UpdatePersonalData_style_1.styles.input]
                                    : [UpdatePersonalData_style_1.styles.phoneNumberField] }),
                            (error.phoneEmpty ||
                                error.mobileShort ||
                                error.mobileLong) && (react_1.default.createElement(atome_1.Text, { style: [UpdatePersonalData_style_1.styles.errorText] },
                                error.phoneEmpty && enums_1.ErrorMessages.PHONE_EMPTY,
                                error.mobileShort && enums_1.ErrorMessages.PHONE_SHORT,
                                error.mobileLong && enums_1.ErrorMessages.PHONE_LONG)))),
                    react_1.default.createElement(react_native_1.View, { style: [UpdatePersonalData_style_1.styles.marginRow] },
                        react_1.default.createElement(atome_1.Label, { style: [UpdatePersonalData_style_1.styles.label] }, "E-Mail-Adresse"),
                        react_1.default.createElement(atome_1.InputField, { hasError: error.emailEmpty || error.emailCorrect, onChange: setEmail, value: email, isEditable: false, style: [
                                Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                    ? [UpdatePersonalData_style_1.styles.input]
                                    : UpdatePersonalData_style_1.styles.emailFieldNotAllowed,
                            ] }),
                        error.emailEmpty && (react_1.default.createElement(atome_1.Text, { style: [UpdatePersonalData_style_1.styles.errorText] }, enums_1.ErrorMessages.EMPTY_FIELD)),
                        error.emailCorrect && (react_1.default.createElement(atome_1.Text, { style: [UpdatePersonalData_style_1.styles.errorText] }, enums_1.ErrorMessages.EMAIL_REQUIREMENTS))),
                    saveSuccess && (react_1.default.createElement(react_native_1.View, { style: [
                            Breakpoints_1.isDesktop
                                ? null
                                : [GlobalStyles_1.globalStyles.row, UpdatePersonalData_style_1.styles.saveMessageContainer],
                        ] },
                        react_1.default.createElement(atome_1.Text, { style: [UpdatePersonalData_style_1.styles.saveMessageText] }, "Speichern erfolgreich"))),
                    react_1.default.createElement(react_native_1.View, { style: [
                            GlobalStyles_1.globalStyles.row,
                            UpdatePersonalData_style_1.styles.marginRow,
                            UpdatePersonalData_style_1.styles.buttonContainer,
                        ] },
                        react_1.default.createElement(react_native_1.Pressable, { pointerEvents: isSaving ? 'none' : 'auto', style: [
                                isSaving ? UpdatePersonalData_style_1.styles.buttonLoading : UpdatePersonalData_style_1.styles.button,
                                GlobalStyles_1.globalStyles.saveButtonContainer,
                            ], onPress: save },
                            isSaving ? react_1.default.createElement(InputLoader_1.default, null) : null,
                            react_1.default.createElement(atome_1.Text, { style: [UpdatePersonalData_style_1.styles.buttonText] }, "Speichern")),
                        Object.values(error).find(e => e) && (react_1.default.createElement(atome_1.Text, { style: [UpdatePersonalData_style_1.styles.errorText] }, enums_1.ErrorMessages.ERROR))))))));
}
exports.UpdatePersonalData = UpdatePersonalData;
